'use strict';

module.exports = function () {
  return {
    $get: [
      '$injector',
      'FirebaseUtil',
      'AbstractDomainClass',
      function ($injector, FirebaseUtil, AbstractDomainClass) {
        function isMeasured(Class) {

          //TODO consider converting to a read-only linked document?
          Class.$getMetricsRef = function $getMetricsRef(id) {
            return FirebaseUtil.firebaseRef(`${Class.COLLECTION}-metrics/${id}/data`);
          };

          Class.prototype.$getMetricsRef = function $getMetricsRef() {
            return Class.$getMetricsRef(this.$id);
          };

          // TODO: this now needs work since it may return null. maybe it should temporarily watch the FB location until the server finishes generating the metrics
          //   maybe it should generate the domain instance no matter what with $get so that it is still bound to firebase
          //   OTOH maybe metrics should not be handled this way anyway and stick to lower level view bindings for now?
          Class.prototype.$getMetrics = AbstractDomainClass.cacheResult(`${Class.$name}-$getMetrics`, function () {
            return FirebaseUtil.read(`${Class.COLLECTION}-metrics/${this.$id}/data`);
          });
        }

        return isMeasured;
      }]
  }
};



// WEBPACK FOOTER //
// ./src/js/core-utilities/domain/MetricMixin.js